import script from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=08a4976d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a4976d"]])

export default __exports__